<template>
    <div v-if="printKugelPaesse">
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" placeholder clearable
                      label="Suchen" filled single-line hide-details dense class="mx-5 mt-2"/>
        <v-data-table :headers="headers" :items="printKugelPaesse.passList" :search="search">
            <template v-slot:header.selected="{ header }">
                <v-checkbox v-model="selectAll" @click.stop small class="mt-0 d-inline-block " hide-details>
                    <template v-slot:label>
                        <span style="font-size: 12px">Pässe (alle auswählen)</span></template>
                </v-checkbox>
            </template>
            <template v-slot:item.ownerType="{ item }">
                <span class="text-capitalize">{{item.ownerType}}</span>
            </template>
            <template v-slot:item.gueltigBis="{ item }">
                {{getGueltigBis(item.gueltigBis)}}
            </template>
            <template v-slot:item.tsLastPassPrint="{ item }">
                {{getFullDate(item.tsLastPassPrint)}}
            </template>
            <template v-slot:item.selected="{ item }">
                <div class="text-no-wrap">
                    <v-checkbox v-model="item.selected"></v-checkbox>
                </div>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn icon @click="askForSetPrintStatus(item)">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>
        <div class="text-right pr-5">
            <v-btn @click="createDruckListe()" color="primary">
                <v-icon class="mr-2">mdi-card-account-details</v-icon>Kugelpass erzeugen</v-btn>
        </div>
        <kugel-paesse-vorschau :print-kugel-paesse="printKugelPaesse"/>
        <confirm-dialog :open="confirmDelete.open" :header="confirmDelete.header"
                        :question="confirmDelete.question"
                        @reply="setPrintStatus" query-parameter="confirmPassPrintReset">
        </confirm-dialog>
    </div>
</template>

<script>
import RouterServices from "@/utilities/services/router/routerServices";
import KugelPaesseVorschau from "@/views/kugeln/paesse/kugelPaesseVorschau";
import TimeStamp from "@/services/timeStamp";
import {Kugel} from "@/services/data/kugeln/kugel";
import ConfirmDialog from "@/components/elements/confirmDialog";

export default {
    name: "kugel-paesse-liste",
    components: {ConfirmDialog, KugelPaesseVorschau},
    props: ['printKugelPaesse'],
    data: () => ({
        search: null,
        headers: [
            {text: 'Kugel-Nr', value: 'nr'},
            {text: 'Name', value: 'ownerName'},
            {text: 'Besitzer', value: 'ownerType'},
            {text: 'Kommentar', value: 'kommentar'},
            {text: 'Gültig bis', value: 'gueltigBis'},
            {text: 'Letzter Druck', value: 'tsLastPassPrint'},
            {text: '', value: 'selected'},
            {text: '', value: 'actions'}
        ],
        selectAll: false,
        confirmDelete: {
            open: false,
            question: '',
            item: null,
        },
    }),
    methods: {
        getGueltigBis(gueltigBis){
            return gueltigBis ? TimeStamp.getStringDotDateFromString(gueltigBis) : 'unbegrenzt'
        },
        getFullDate(ts){
            return ts ? TimeStamp.getLocalStringFromGMTts(ts) : '-'
        },
        createDruckListe(){
            RouterServices.pushRouteQueryParameter(this.$router, this.$route, 'kugelPassVorschau', true)
        },
        async setPrintStatus(reply){
            if ( reply ) {
                const kugel = new Kugel(this.confirmDelete.item, null, this.confirmDelete.item.ownerType, null)
                await kugel.setPrintStatus(false)
                this.printKugelPaesse.changePrintStatus(this.confirmDelete.item)
            }
            this.confirmDelete.open = false;
        },
        askForSetPrintStatus(pass){
            this.confirmDelete.item = pass;
            this.confirmDelete.header = 'Aus Druckliste entfernen';
            this.confirmDelete.question = 'Möchtest du den Pass ' + pass.nr + ' von ' + pass.ownerName +
                ' wirklich aus der Druckliste löschen?';
            this.confirmDelete.open = true;
        },
    },
    watch: {
        selectAll(to){ this.printKugelPaesse.setSelected(to) }
    }
}
</script>

<style scoped>

</style>